import script from "./ConfigurationModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./ConfigurationModal.vue?vue&type=script&setup=true&lang=ts"

import "./ConfigurationModal.vue?vue&type=style&index=0&id=01a2472f&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-01a2472f"]])

export default __exports__